import { render, staticRenderFns } from "./stationery.vue?vue&type=template&id=55bb37a0&"
import script from "./stationery.vue?vue&type=script&lang=js&"
export * from "./stationery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports